var map = {
	"./Journey.svg": "8c4d",
	"./accessibility.svg": "9049",
	"./add-icon.svg": "6209",
	"./alert.svg": "659f",
	"./approved.svg": "2282",
	"./arrow-back.svg": "b8a8",
	"./arrow-down.svg": "c874",
	"./arrow-forward.svg": "e1cd",
	"./arrow-up.svg": "a3f8",
	"./borderless-plus-button.svg": "c7b4",
	"./building.svg": "a528",
	"./bulk-add-icon.svg": "fb1e",
	"./change-icon.svg": "e310",
	"./checkbox-error.svg": "9e22",
	"./checked-checkbox.svg": "1afb",
	"./checked-radio.svg": "9fff",
	"./client_alert.svg": "3204",
	"./close-icon.svg": "3e79",
	"./closed-black-eye.svg": "4034",
	"./copy-icon.svg": "d00c",
	"./default-qualification-icon.svg": "84b9",
	"./domestic-collection.svg": "501a",
	"./download-icon.svg": "a1d8",
	"./edit-icon.svg": "f4c4",
	"./filter.svg": "2376",
	"./green-star.svg": "a46c",
	"./help-icon.svg": "7975",
	"./househould-visit.svg": "ef54",
	"./journey-blue-logo.svg": "35e2",
	"./journey-green-logo.svg": "71cd",
	"./logo-journey-full.svg": "d79c",
	"./opened-black-eye.svg": "0c74",
	"./parking.svg": "7346",
	"./phone.svg": "c3bb",
	"./presential.svg": "404a",
	"./primary_data.svg": "4197",
	"./push-pin.svg": "3248",
	"./radio-error.svg": "44fe",
	"./rating-icon-1.svg": "584f",
	"./rating-icon-2.svg": "d4ec8",
	"./rating-icon-3.svg": "5749",
	"./red-presential.svg": "9542",
	"./red-telemedicine.svg": "85f8",
	"./refused.svg": "eee8",
	"./schedule.svg": "6b6f",
	"./search-icon.svg": "7669",
	"./secondary-upload-file-icon.svg": "6a66",
	"./secondary_data.svg": "3142",
	"./selected-presential.svg": "76d3",
	"./selected-telemedicine.svg": "4382",
	"./star-gray.svg": "b794",
	"./star-green.svg": "d8bb",
	"./star.svg": "cc90",
	"./telemedicine.svg": "bf08",
	"./trash-icon.svg": "428fe",
	"./unchecked-checkbox.svg": "fb21",
	"./unchecked-radio.svg": "66e6",
	"./upload-file-icon.svg": "c785",
	"./white-arrow.svg": "6806"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";